module.exports = __webpack_public_path__ + "static/media/Casino-Days-Two-Lines-White-BG-800x480.9b1748e0.png";